const isIframe = () => {
  const isAndroidApp = navigator.userAgent.search("cco Android WebViewApp")
  const isiOSApp = navigator.userAgent.search("cco iOS WebViewApp")

  if(isAndroidApp !== -1 || isiOSApp !== -1) {
    return true
  } else {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true; // If an error occurs, assume it's an iframe (for safer side)
    }
  }

};

export default isIframe;